// extracted by mini-css-extract-plugin
module.exports = {"aboutThumb":"About_aboutThumb__1w-Bh"};